import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import theme from './theme/theme';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/Auth/ProtectedRoute';
import Layout from './components/Layout/Layout';
import EnhancedDashboard from './pages/Dashboard/EnhancedDashboard';
import Categories from './pages/Categories/Categories';
import ProductsWeightBased from './pages/Products/ProductsWeightBased';
import ProductDetail from './pages/Products/ProductDetail';
import Orders from './pages/Orders/Orders';
import DeliveryAgents from './pages/DeliveryAgents/DeliveryAgents';
import Users from './pages/Users/Users';
import PreOrders from './pages/PreOrders/PreOrders';
import Notifications from './pages/Notifications/Notifications';
import Settings from './pages/Settings/Settings';
// import Analytics from './pages/Analytics/Analytics';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Router>
          <ProtectedRoute>
            <Routes>
              <Route path="/" element={
                <Layout title="Dashboard">
                  <EnhancedDashboard />
                </Layout>
              } />
          <Route path="/categories" element={
            <Layout title="Categories">
              <Categories />
            </Layout>
          } />
          <Route path="/products" element={
            <Layout title="Products">
              <ProductsWeightBased />
            </Layout>
          } />
          <Route path="/products/:id" element={
            <Layout title="Product Details">
              <ProductDetail />
            </Layout>
          } />
          <Route path="/orders" element={
            <Layout title="Orders">
              <Orders />
            </Layout>
          } />
          <Route path="/delivery-agents" element={
            <Layout title="Delivery Agents">
              <DeliveryAgents />
            </Layout>
          } />
          <Route path="/users" element={
            <Layout title="Users">
              <Users />
            </Layout>
          } />
          <Route path="/pre-orders" element={
            <Layout title="Pre-Orders">
              <PreOrders />
            </Layout>
          } />
          <Route path="/notifications" element={
            <Layout title="Notifications">
              <Notifications />
            </Layout>
          } />
          <Route path="/settings" element={
            <Layout title="Settings">
              <Settings />
            </Layout>
          } />
          {/* Uncomment as you create these pages */}
          {/*
          <Route path="/analytics" element={
            <Layout title="Analytics">
              <Analytics />
            </Layout>
          } /> */}
            </Routes>
          </ProtectedRoute>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
